import styled from 'styled-components'

export const HeaderContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.large};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-bottom: none;
  border-radius: ${({ theme }) =>
    `${theme.borderRadius.medium} ${theme.borderRadius.medium} 0 0`};
  background: ${({ theme }) => theme.colors.background.primary};

  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 1fr 400px;
    gap: ${({ theme }) => theme.spacing.large};
    align-items: start;
  }
`

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 1023px) {
    margin-top: ${({ theme }) => theme.spacing.medium};
  }
`

export const TitleSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.medium};
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`

export const TitleContent = styled.div`
  flex: 1;
  min-width: 0;
`

export const PlanTypeTitle = styled.h3`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  line-height: 1.3;
`

export const ZoneName = styled.div`
  margin-top: ${({ theme }) => theme.spacing.xsmall};
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 1.4;
`

export const StatusBadgesRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  flex-wrap: wrap;
  padding: ${({ theme }) => `${theme.spacing.small} 0`};
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
`

export const StatusBadgesRowWithBorder = styled(StatusBadgesRow)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
`

export const AdoptionDateRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.large};
  padding-top: ${({ theme }) => theme.spacing.small};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-style: italic;
`

export const PurposeSection = styled.div`
  margin-top: ${({ theme }) => theme.spacing.medium};
  padding-top: ${({ theme }) => theme.spacing.medium};
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
`

export const PurposeToggle = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.secondary};
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
  }

  svg {
    transition: transform ${({ theme }) => theme.transitions.fast};
  }
`

export const PurposeContent = styled.div<{ $expanded: boolean }>`
  max-height: ${({ $expanded }) => ($expanded ? '500px' : '0')};
  overflow: hidden;
  transition: max-height ${({ theme }) => theme.transitions.medium};
  margin-top: ${({ $expanded, theme }) =>
    $expanded ? theme.spacing.small : '0'};
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const ConstructionArrangementSection = styled.div`
  margin-top: ${({ theme }) => theme.spacing.medium};
  padding-top: ${({ theme }) => theme.spacing.medium};
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
`

export const SectionLabel = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.secondary};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: ${({ theme }) => theme.spacing.xsmall};
`

export const ClickableValue = styled.span<{ $hasReference: boolean }>`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: ${({ $hasReference }) => ($hasReference ? 'pointer' : 'default')};
  text-decoration: ${({ $hasReference }) =>
    $hasReference ? 'underline dotted' : 'none'};
  text-decoration-color: ${({ theme }) => theme.colors.border.default};

  &:hover {
    color: ${({ $hasReference, theme }) =>
      $hasReference ? theme.colors.primary : 'inherit'};
    text-decoration-color: ${({ $hasReference, theme }) =>
      $hasReference ? theme.colors.primary : 'inherit'};
  }
`
